const getRemainingDays = (data) => {
  const { start, end } = data;
  
  const total = Math.floor((end - start) / (1000 * 60 * 60 * 24));
  
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  
  if (end <= tomorrow) {
    return { total, remaining: 0 };
  }
  
  const rangeStart = start > tomorrow ? start : tomorrow;
  
  const remaining = Math.floor((end - rangeStart) / (1000 * 60 * 60 * 24));
  
  return { total, remaining };
};

export const calculateRemainingValue = (subscription) => {
  const { total, remaining } = getRemainingDays({
    start: new Date(subscription.current_period_start),
    end: new Date(subscription.current_period_end),
  });

  const amount = subscription.plan_amount * 100;
  const remainingAmount = (amount * remaining) / total;
  const amountToRefund = Number(remainingAmount.toFixed(2));

  return { amount: Math.trunc(amountToRefund), total, remaining };
};

export const haveToShowRefundInfo = subscription => {
  const allowByPaymentMethod = subscription?.payment_method === "credit_card";
  const allowBySubscriptionStatus = ["active", "paid", "canceled"].includes(
    subscription?.status
  );

  return allowByPaymentMethod && allowBySubscriptionStatus;
};